const defaultState = {
    clinics: [],
}

const SET_CLINICS = "SET_CLINICS"

export const clinicsReducer = (state = defaultState, action) => {
    switch (action.type) {
        case SET_CLINICS:
            return {...state, clinics: action.payload}

        default:
            return state
    }
}

export const setClinicsAction = (payload) => ({type: SET_CLINICS, payload})
